var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-361 -61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m361 61v12h13v-12zm12.512 2.72h-9.425v-2.24h9.425zm-6.296.48h2.965v8.32h-2.965zm-.488 8.32h-2.64v-8.32h2.64zm-3.128-11.04v2.24h-2.113v-2.24zm-2.113 2.72h2.113v8.32h-2.113zm9.182 8.32v-8.32h2.843v8.32z",
    fill: "#b1c2c9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 27,
    rx: 2,
    stroke: "#ececec",
    width: 64,
    x: 320.5,
    y: 53.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGray);
export default __webpack_public_path__ + "static/media/table-gray.437f2c76f00a9c4b4c17bd28f5d3d483.svg";
export { ForwardRef as ReactComponent };